export default {
  title: 'Items',
  order_note: 'Order note',
};
